export { AmortizationModel } from "./amortization.model";
export { AmortizationsService } from "./amortizations.service";
